import React, { useEffect } from 'react';
import PersonInList from '../../../../objects/PersonInList';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import { withTranslation } from 'react-i18next';
import PersonListContainer from '../../../common/PersonListContainer';
import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import { Grid } from 'semantic-ui-react';
import CommonTagsInputWrapper from '../../../common/CommonTagsInputWrapper';
import { error } from 'console';

type Props = {
  values: any;
  initialData: any;
  errors: any;
  mode: string;
  setOverridePersonState: (arg: boolean) => void;
  validateOnChange: boolean;
  setFieldValue: (arg1: string, arg2: string) => void;
  disabled: boolean;
};

const IContactListContainer = ({
  values,
  initialData,
  errors,
  mode,
  setOverridePersonState,
  validateOnChange,
  setFieldValue,
  disabled,
}: Props) => {
  useEffect(() => {
    initOrgUnit();
  });

  const getOrgUnitAsEntity = (orgUnitName: string) => {
    return { name: orgUnitName };
  };

  const getOrgUnitDepAndGroup = (orgUnit: string) => {
    return orgUnit.split('-', 2).join('-');
  };

  useEffect(() => {
    const { contacts } = values;

    if (contacts.length > 0) {
      let newFirstPersonDep = contacts[0].person.orgUnit
        ? getOrgUnitDepAndGroup(contacts[0].person.orgUnit)
        : null;

      if (newFirstPersonDep) {
        values.orgUnit = getOrgUnitAsEntity(newFirstPersonDep);
      }
    }
  }, values.contacts.length);

  const initOrgUnit = () => {
    if (!values.orgUnit)
      if (values.contacts && values.contacts.length > 0 && values.contacts[0].person.orgUnit) {
        let newOrgUnit = getOrgUnitDepAndGroup(values.contacts[0].person.orgUnit);
        values.orgUnit = { name: newOrgUnit };
      } else values.orgUnit = null;
  };

  const getContactListContainerContent = () => {
    return (
      <>
        <Grid stackable columns={1} verticalAlign="bottom">
          <GridColumnInputWrapper
            name="orgUnit"
            label="inventory.details.page.contact.list.container.org.unit.input"
            specialRequiredCondition={true}
            setFieldValue={setFieldValue}
            disabled={disabled}
            render={(props: any) => (
              <CommonTagsInputWrapper
                {...props}
                suggestionList={initialData.orgUnitList}
                matchProperty="name"
                displayProps="name"
                value={values.orgUnit}
                maxTags={1}
                onlyUnique={true}
              />
            )}
          />
        </Grid>
        <PersonListContainer
          values={values}
          newPersonEntity={PersonInList}
          arrayPropName="contacts"
          fieldPropName="person"
          showEmailHandler={true}
          showNoEmailAvailable={true}
          showDeleteHandler={true}
          showAddNew={true}
          sort={true}
          isNotMissingLmsCourses={true}
          showNotPresentAtCernWarning
          errors={errors}
          mode={mode}
          setOverridePersonState={setOverridePersonState}
          validateOnChange={validateOnChange}
          disabled={disabled}
        />
      </>
    );
  };

  return (
    <AccordionWrapper
      closable={false}
      accordionTitle="inventory.details.page.contact.list.container.title"
      tooltip="inventory.details.page.contact.list.container.tooltip"
      render={getContactListContainerContent}
      className=""
      isRequired={true}
    />
  );
};

export default withTranslation()(IContactListContainer);
